export const REGISTER_DO_REGISTER_BEGIN = 'REGISTER_DO_REGISTER_BEGIN';
export const REGISTER_DO_REGISTER_SUCCESS = 'REGISTER_DO_REGISTER_SUCCESS';
export const REGISTER_DO_REGISTER_FAILURE = 'REGISTER_DO_REGISTER_FAILURE';
export const REGISTER_DO_REGISTER_DISMISS_ERROR = 'REGISTER_DO_REGISTER_DISMISS_ERROR';



// WEBPACK FOOTER //
// ./src/features/register/redux/constants.js